import "reflect-metadata";
import Vue from "vue";
import App from "./App.vue";
import "@/services";
import vuetify from "./plugins/vuetify";
import "./assets/css/material.css";
import "./assets/css/theme.css";
import "@/plugins/extensions";
import "@fontsource/poppins";
import "./registerServiceWorker";
import AuthBrandPanel from "@/components/AuthBrandPanel.vue";
import { container } from "tsyringe";
import { EServices } from "./types";

Vue.config.productionTip = false;

Vue.component("AuthBrandPanel", AuthBrandPanel);

new Vue({
  router: container.resolve(EServices.router),
  store: container.resolve(EServices.store),
  vuetify,
  provide: {
    [EServices.auth]: container.resolve(EServices.auth),
    [EServices.rates]: container.resolve(EServices.rates),
    [EServices.store]: container.resolve(EServices.store),
    [EServices.crypto]: container.resolve(EServices.crypto),
    [EServices.transactions]: container.resolve(EServices.transactions),
    [EServices.security]: container.resolve(EServices.security),
    [EServices.notifications]: container.resolve(EServices.notifications),
    [EServices.complaint]: container.resolve(EServices.complaint),
    [EServices.banks]: container.resolve(EServices.banks),
    [EServices.account]: container.resolve(EServices.account),
    [EServices.announcement]: container.resolve(EServices.announcement),
    [EServices.wallets]: container.resolve(EServices.wallets),
    [EServices.referrals]: container.resolve(EServices.referrals),
    [EServices.ranks]: container.resolve(EServices.ranks),
    [EServices.biometric]: container.resolve(EServices.biometric),
    [EServices.kyc]: container.resolve(EServices.kyc),
  },
  render: (h) => h(App),
}).$mount("#app");
